import moment from 'moment';

interface IsValidDateProps {
  date: string | Date;
  dateFormat: string;
}

export default function isValidDate({
  date,
  dateFormat,
}: IsValidDateProps): boolean {
  let isValidDate = false;

  const RegExpFormat = /^\d{2}([./-])\d{2}\1\d{4}$/;

  const formatValidDate = RegExpFormat.test(String(date));

  if (formatValidDate) {
    const validDate = moment(date, dateFormat).isValid();
    validDate ? (isValidDate = true) : (isValidDate = false);
  }

  return isValidDate;
}
